export const BANNER_ASPECT_RATIO = { xs: '16 / 9', sm: '32 / 7' };

export const BANNER_AUTOPLAY_INTERVAL_MS = 5000;
